import { IShader, ShaderBase } from '../shader';
import { PBRMetallicRoughnessMaterial, Color3, Texture, Scene, Material } from '@babylonjs/core';
import { stringUtil } from '@/models/stringUtil';

export class ShaderH3162 extends ShaderBase implements IShader {

    public diffuse: string = 'diffuse/H3162.jpg';
    public normal: string = 'diffuse/H3162_normal.jpg';
    public avatar: string = 'diffuse/H3162_icon.jpg';
    public text: string = 'brownOak';

    public get key(): string { return 'ShaderH3162'; }

    public getMaterial(scene: Scene, light: string = ''): PBRMetallicRoughnessMaterial {
        const material = new PBRMetallicRoughnessMaterial('material', scene);
        material.baseColor = new Color3(0.88, 0.88, 0.88);
        material.metallic = 0.07;
        material.roughness = 0.65;

        if (this.diffuse) {
            const url = stringUtil.createDownloadUrl(this.diffuse);
            const baseTexture = new Texture(url, scene);
            baseTexture.coordinatesIndex = 0;
            baseTexture.uScale = 1.54;
            baseTexture.vScale = 1.54;
            material.baseTexture = baseTexture;
        }

        if (this.normal) {
            const url = stringUtil.createDownloadUrl(this.normal);
            const normalTexture = new Texture(url, scene);
            normalTexture.uScale = 3;
            normalTexture.vScale = 3;
            material.normalTexture = normalTexture;
        }

        if (light) {
            const url = stringUtil.createDownloadUrl(light);
            const lightmapTexture = new Texture(url, scene);
            lightmapTexture.coordinatesIndex = 1;
            lightmapTexture.vScale = -1;
            material.useLightmapAsShadowmap = true;
            material.lightmapTexture = lightmapTexture;
        }

        material.backFaceCulling = false;
        return material;
    }

    addLight(scene: Scene, material: Material, light: string): Material {
        return super.addLight(scene, material, light);
    }
}
